import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import documentEmptyState from '../../../images/document_empty_state.svg';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  iconWrapper: {
    width: '280px',
    height: '280px',
  },
  documentEmptyStateImg: {
    width: '100%',
    height: '100%',
  },
}));

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const DocumentEmptyState = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper} data-spec="document-empty-state">
      <div className={classes.iconWrapper}>
        <img src={documentEmptyState} alt="no documents found" className={classes.documentEmptyStateImg} />
      </div>
      <div className={classes.textWrapper}>
        <Typography variant="h6">No documents found</Typography>
        <Typography variant="body1">There are no documents associated with this property.</Typography>
      </div>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default DocumentEmptyState;
